'use client'
import { Drawer, Flex, Stack } from '@mantine/core'
import { useSession } from 'next-auth/react'
import { FC } from 'react'
import { hamburgerMenuStore } from '../Header/Store'
import drawerClasses from './Drawer.module.css'
import { DashboardLinks, Profile, ScheduleACall } from './components'

export const HamburgerMenu: FC = () => {
  const { close, opened } = hamburgerMenuStore()
  const { data: session, status } = useSession()
  const hasAuthenticatedSession =
    status === 'authenticated' && Boolean(session?.access_token)

  return (
    <Drawer
      offset={0}
      opened={opened}
      size='xs'
      onClose={close}
      position='right'
      classNames={drawerClasses}
      withCloseButton={false}
      c='white'
    >
      <Flex direction='column' justify='space-between' h='100%'>
        {hasAuthenticatedSession ? <DashboardLinks /> : <div />}
        <Stack>
          <ScheduleACall />
          {hasAuthenticatedSession ? <Profile /> : null}
        </Stack>
      </Flex>
    </Drawer>
  )
}
